<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset, errors}" ref="observer" slim>
    <b-tab :title-link-class="hasErrors(errors) ? 'has-error' : ''">
      <template v-slot:title>
        {{ $t('Text Message') }}
        <span v-if="hasErrors(errors)" style="width: 20px;height: 20px" id="home-exclamation-icon">
          <font-awesome-icon class="text-danger hover-cursor" icon="exclamation-circle"/>
        </span>
        <b-tooltip v-if="hasErrors(errors)" target="home-exclamation-icon"
                   :title="$t('You have validation errors')"/>
      </template>
      <div class="row">
        <div class="col-md-12">
          <input-widget type="checkbox" :model="model" attribute="enable_sms" is-switch/>
        </div>
        <div v-if="model.template_type && model.template_type.requires_to_attribute" class="col-md-12">
          <input-widget :rules="model.enable_sms ? 'required' : ''" :model="model" attribute="sms_to" type="tags"/>
        </div>
        <div class="col-md-12">
          <translatable-input-widget :hint="false" :model="model" :fields="model.getSmsFields()" :rules="rules"
                                     :errors="errors" @onCkeditorReady="$emit('onCkeditorReady')"/>
        </div>
      </div>
      <template-variables v-if="model.template_type" :variables="model.template_type.sms_variables"/>
    </b-tab>
  </ValidationObserver>
</template>

<script>
  import InputWidget from "../../../core/components/input-widget/InputWidget";
  import TemplateVariables from "@/modules/setup/templates/TemplateVariables";
  import TranslatableInputWidget from "@/core/widgets/TranslatableInputWidget";

  export default {
    name: "SmsForm",
    components: {TranslatableInputWidget, TemplateVariables, InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      }
    },
    data() {
      return {};
    },
    computed: {
      rules() {
        return {
          sms_body: this.model.enable_sms ? 'required' : null,
        }
      }
    },
    methods: {
      hasErrors(errors) {
        for (let i in errors) {
          if (errors[i].length > 0) {
            return true;
          }
        }
        return false;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
